import { c as _c } from "react/compiler-runtime";
import { IcoKey16 } from '@onefootprint/icons';
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import BaseHoverCard from '../base-hover-card';
import ApiKeyDetails from './api-key-details';
const ApiKeyDisplay = t0 => {
  const $ = _c(13);
  const {
    name,
    scopes,
    roleName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.apiKeys"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${t2} (${name})`;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${name} ${t4}`;
  let t6;
  if ($[5] !== name || $[6] !== roleName || $[7] !== scopes) {
    t6 = <ApiKeyDetails name={name} scopes={scopes} roleName={roleName} />;
    $[5] = name;
    $[6] = roleName;
    $[7] = scopes;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <BaseHoverCard textTrigger={t3} titleText={t5} titleIcon={IcoKey16}>{t6}</BaseHoverCard>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default ApiKeyDisplay;
function _temp($) {
  return $.apiKey;
}
function _temp2($_0) {
  return $_0.apiKeyDetails;
}